import { useAppSelector } from '@hooks/redux/redux';
import { ErrorBoundary } from '@components/error-boundary';
import { FilialQuota } from './components/filial-quota';
import { FilialStorage } from './components/filial-storage';
import { UsersQuotaList } from './components/users-quota-list';
import { Flex } from '@mantine/core';
import { useStyles } from '../../../styles';
import { MassAddQuota } from './components/mass-add-quota';
import { CalculateQuota } from './components/calculate-quota';
import { isSuperAdmin } from '@/lib/utils/access';

const DiskSpasePage = () => {
  const { classes } = useStyles();
  const { filial } = useAppSelector((state) => state.filials);
  const currentUser = useAppSelector((state) => state.userInfo.User);

  return (
    <ErrorBoundary componentTitle="Disk space section">
      {filial && (
        <Flex className={classes.container} direction="column">
          <FilialQuota filial={filial} />
          {isSuperAdmin(currentUser) && <FilialStorage filial={filial} />}
          <UsersQuotaList filial={filial} />
          <CalculateQuota />
          <MassAddQuota />
        </Flex>
      )}
    </ErrorBoundary>
  );
};

export default DiskSpasePage;
